module.exports = __webpack_public_path__ + "static/media/emobility.63a1748c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/emobility.jpg
// module id = 1532
// module chunks = 0